module.exports = __webpack_public_path__ + "static/media/motor.49fa198f.png";